import axios from 'axios'

const state = {
  loading: false,
  error: null
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

const actions = {
  async fetchDashboardData({ commit }, { startDate, endDate }) {
    commit('SET_LOADING', true)
    try {
      const params = {}
      if (startDate && endDate) {
        params.startDate = startDate.toISOString()
        params.endDate = endDate.toISOString()
      }

      const response = await axios.get('/dashboard', { params })
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors du chargement des données du tableau de bord')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchQuestionsByCategory({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get('/dashboard/questions-by-category')
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors du chargement des questions par catégorie')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchActivityData({ commit }, { startDate, endDate }) {
    commit('SET_LOADING', true)
    try {
      console.log('Début fetchActivityData avec dates:', { startDate, endDate });
      
      const params = {}
      if (startDate && endDate) {
        params.startDate = startDate.toISOString()
        params.endDate = endDate.toISOString()
      }
      console.log('Paramètres de requête:', params);

      const response = await axios.get('/dashboard/activity', { params })
      console.log('Réponse de l\'API activity:', response.data);
      return response.data
    } catch (error) {
      console.error('Erreur dans fetchActivityData:', error.response?.data || error.message);
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors du chargement des données d\'activité')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchRecentQuestions({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get('/dashboard/recent-questions')
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors du chargement des questions récentes')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchRecentConversations({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get('/dashboard/recent-conversations')
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors du chargement des conversations récentes')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  isLoading: state => state.loading,
  error: state => state.error
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 